var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-grid',{staticClass:"span-6"},[_c('n-text',{attrs:{"color":"grey-dark"}},[_vm._v(_vm._s(_vm.time))]),_c('n-text',{staticClass:"span-5",attrs:{"color":"grey-dark"}},[_vm._v(_vm._s(_vm.address))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }